// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"b7c830d5","142":"64de51d3","227":"b7c830d5","483":"ea897239"}[chunkId] + ".chunk.css";
};